import React from 'react';
import { SONG_NOTE_STATUS } from '../../../../services/songNotesModel';
import './StateChip.css';

/**
 * The privacy grammar in one place (design handoff 2026-07-22):
 *
 *   captured — dashed border + eye-slash + "Only you". Private. The identical
 *              treatment marks the teacher-only Recap tier; if either surface
 *              changes, they change together.
 *   focus    — bullseye, --cyv-info hue, solid border. Delivered, being worked.
 *   landed   — check, --cyv-success tint fill. Delivered and applied — the win.
 *
 * Meaning rides on the WORD + ICON; the status hue lives on icon/border/tint
 * only and is reinforcement. The label itself is always --text-body.
 */
const CHIP = {
	[SONG_NOTE_STATUS.CAPTURED]: { icon: 'fa-eye-slash', label: 'Only you' },
	[SONG_NOTE_STATUS.FOCUS]: { icon: 'fa-bullseye', label: 'Focus' },
	[SONG_NOTE_STATUS.LANDED]: { icon: 'fa-circle-check', label: 'Landed' },
};

const StateChip = ({ status, label = null }) => {
	const spec = CHIP[status] || CHIP[SONG_NOTE_STATUS.CAPTURED];
	return (
		<span className={`ld-chip ld-chip--${status || SONG_NOTE_STATUS.CAPTURED}`}>
			<i className={`fa-sharp fa-solid ${spec.icon}`} aria-hidden="true" />
			{label || spec.label}
		</span>
	);
};

export default StateChip;
